import { createContext, useContext, useState, useEffect, useCallback } from "react";
import API from "./api";
import { useAuth } from "./auth";

const AIContext = createContext({ enabled: false, consent: null, aiOn: false, setConsent: async () => {} });

export function AIProvider({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState({ enabled: false, consent: null });

  useEffect(() => {
    if (!user) { setStatus({ enabled: false, consent: null }); return; }
    API.get("/ai/status").then(({ data }) => setStatus(data)).catch(() => setStatus({ enabled: false, consent: null }));
  }, [user]);

  const setConsent = useCallback(async (granted) => {
    const { data } = await API.post("/ai/consent", { granted });
    setStatus(data);
  }, []);

  const aiOn = status.enabled && status.consent === true;
  return (
    <AIContext.Provider value={{ ...status, aiOn, setConsent }}>
      {children}
    </AIContext.Provider>
  );
}

export const useAI = () => useContext(AIContext);
